module.exports = __webpack_public_path__ + "static/media/eye.7f9bac47.svg";